document.addEventListener("DOMContentLoaded", function () {
    const timelines = document.querySelectorAll('.timeline')

    // Loop through each timeline element
    timelines.forEach((timeline) => {
        const timelineItems = timeline.querySelectorAll('.timeline__item')

        // Loop through each timeline item
        timelineItems.forEach((item) => {
            const collapse = item.querySelector('.timeline__collapse')
            const date = item.querySelector('.timeline__date')
            const dateMin = date.getAttribute('data-min')
            const dateMax = date.getAttribute('data-max')

            // Check if the collapse element has the "show" class
            if (collapse.classList.contains('show')) {
                // Modify the date element based on the presence of "dateMin" and "dateMax"
                if (dateMin != dateMax) {
                    if (dateMin && dateMax) {
                        date.innerHTML = `${dateMin}<span class="dash">-</span>${dateMax}`
                    } else if (dateMin) {
                        date.innerHTML = `${dateMin}`
                    } else {
                        date.innerHTML = `${dateMax}`
                    }
                } else {
                    date.innerHTML = dateMin
                }
            } else {
                // Modify the date element based on the presence of "dateMin" and "dateMax"
                if (dateMin) {
                    date.innerHTML = dateMin
                } else {
                    date.innerHTML = dateMax
                }
            }

            // Set up an event listener for the "show.bs.collapse" event
            collapse.addEventListener('show.bs.collapse', event => {
                // Modify the date element based on the presence of "dateMin" and "dateMax" when the accordion is shown
                if (dateMin != dateMax) {
                    if (dateMin && dateMax) {
                        date.innerHTML = `${dateMin}<span class="dash">-</span>${dateMax}`
                    } else if (dateMin) {
                        date.innerHTML = `${dateMin}`
                    } else {
                        date.innerHTML = `${dateMax}`
                    }
                } else {
                    date.innerHTML = dateMin
                }
            })

            // Set up an event listener for the "hide.bs.collapse" event
            collapse.addEventListener('hide.bs.collapse', event => {
                // Modify the date element based on the presence of "dateMin" and "dateMax" when the accordion is hidden
                if (dateMin) {
                    date.innerHTML = dateMin
                } else {
                    date.innerHTML = dateMax
                }
            })
        })
    })
})